import { InboxMultipleIcon } from './InboxMultipleIcon';

/**
 * author: Google
 * id 6FF18A17-48D4-4173-9CBD-8DB77F5A6E2A
 * name inbox-multiple
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/inbox-multiple.svg
 * tags
 */
export const InboxesIcon = InboxMultipleIcon;
export default InboxesIcon